/**
 * Blog Detail View Counter with LeadID Tracking
 * sessionStorage를 사용한 블로그 상세 페이지 조회 수 관리
 * leadId 기반으로 현재 진행 중인 퍼널을 추적
 * 새로운 도입문의 시작 시 이전 데이터 덮어쓰기
 *
 * ⚠️ DEPRECATED: leadData 관리는 @/services/leadDataService를 사용하세요
 */

import { getLeadData as getLeadDataFromService } from '@/services/leadDataService';

const COUNT_KEY = 'viewCount';
const LEAD_DATA_KEY = 'leadData';

/**
 * 현재 진행 중인 leadData 반환
 * @deprecated Use getLeadData from @/services/leadDataService instead
 * @returns {Object|null} { leadId, companyName, roadAddress, x, y } (없으면 null)
 */
export function getLeadData() {
  console.warn('⚠️ [DEPRECATED] blogViewCounter.getLeadData() - Use @/services/leadDataService instead');
  return getLeadDataFromService();
}

/**
 * 현재 진행 중인 leadData 저장
 * @param {Object} leadData - { leadId, companyName, roadAddress, x, y }
 */
export function setLeadData(leadData) {
  if (leadData) {
    sessionStorage.setItem(LEAD_DATA_KEY, JSON.stringify(leadData));
  }
}

/**
 * 현재 진행 중인 leadId 반환 (하위 호환성)
 * @returns {string|null} 현재 leadId (없으면 null)
 */
export function getCurrentLeadId() {
  const leadData = getLeadData();
  return leadData?.leadId || null;
}

/**
 * 현재 진행 중인 leadId 설정 (하위 호환성)
 * @param {string} leadId - 설정할 leadId
 */
export function setCurrentLeadId(leadId) {
  if (leadId) {
    const existingData = getLeadData() || {};
    setLeadData({ ...existingData, leadId });
  }
}

/**
 * 현재 블로그 조회 수 반환
 * @returns {number|null} 조회 수 (없으면 null)
 */
export function getBlogViewCount() {
  const count = sessionStorage.getItem(COUNT_KEY);
  return count !== null ? parseInt(count, 10) : null;
}

/**
 * 블로그 조회 수 1 증가
 * @returns {number|null} 증가된 조회 수 (view count 없으면 null)
 */
export function incrementBlogViewCount() {
  const current = getBlogViewCount();
  if (current === null) {
    return null; // view count가 없으면 증가시키지 않음
  }
  const newCount = current + 1;
  sessionStorage.setItem(COUNT_KEY, newCount.toString());
  return newCount;
}

/**
 * 블로그 조회 수를 0으로 리셋
 * 도입문의 완료 시 또는 각 퍼널 단계 완료 시 호출
 * 같은 탭에서는 항상 같은 leadId이므로 leadId 비교 불필요
 */
export function resetBlogViewCount() {
  sessionStorage.setItem(COUNT_KEY, '0');
}

/**
 * 블로그 조회 수 완전 제거
 * 광고정보등록 완료 시 호출
 *
 * ⚠️ leadData는 leadDataService.clearLeadData()를 별도로 호출하세요
 */
export function removeBlogViewCount() {
  sessionStorage.removeItem(COUNT_KEY);
  // DEPRECATED: leadData 삭제는 leadDataService.clearLeadData() 사용
  // sessionStorage.removeItem(LEAD_DATA_KEY);
}
